import * as yup from 'yup';

const DEFAULT_MESSAGE = 'Campo obrigatório'

export const ContasPagarSchema = yup.object().shape({
    dadosGerais: yup.object().shape({
    descricao: yup.string().required(DEFAULT_MESSAGE),
  }),  
});
